// extracted by mini-css-extract-plugin
module.exports = {"title":"PostsCard_title__c7mNE","reactions":"PostsCard_reactions__KToAt"};